import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent
} from "@softline/dynamic";
import { AuftragListView } from "./list-view/auftrag.list-view";

export const auftragFieldOk: FieldOkConfig = {
  name: 'auftrag',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{belegnummer}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: AuftragListView
    }
  }
  ]
};
export const auftragMultiselectFieldOk: FieldOkConfig = {
  name: 'auftrag',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{belegnummer}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkMultiselectListViewComponent,
    title: 'Auswahl',
    config: {
      component: AuftragListView
    }
  }
  ]
};

export const auftragQueryFieldOk: FieldOkConfig = {
  name: 'auftrag',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{belegnummer}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: QueryFieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: AuftragListView
    }
  }
  ]
};
